/**
 * Zappyvibe hareket katmanı.
 * [data-zv-reveal] öğeleri görünür alana girince `is-in` sınıfı alır.
 * Varyantlar CSS'te: mask | rise | slide | scale | fade. Gecikme için style="--zv-delay: .2s".
 */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const reveal = (el) => el.classList.add('is-in');

  const observer =
    'IntersectionObserver' in window && !reduce.matches
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          },
          // Eşik 0: maskeli (clip-path) öğelerde görünür alan 0 sayılır, 0.12 eşiğine hiç ulaşılmaz
          { rootMargin: '0px 0px -10% 0px', threshold: 0 }
        )
      : null;

  const scan = (root = document) => {
    root.querySelectorAll('[data-zv-reveal]:not(.is-in)').forEach((el) => {
      if (observer) observer.observe(el);
      else reveal(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // Tema editöründe bölüm eklenince/yenilenince tekrar tara
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
